import { SgFeedback } from './src/SgFeedback.js';
window.customElements.get('sg-feedback') ||
    window.customElements.define('sg-feedback', SgFeedback);
//# sourceMappingURL=index.js.map